import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  messages: [], // { id, sender: 'user' | 'bot', text }
  isLoading: false,
  message: null,
  isOpen: false,
};

export const chatBotSlice = createSlice({
  name: "chatBot",
  initialState,
  reducers: {
    addUserMessage: (state, { payload }) => {
      state.messages.push({
        id: Date.now(),
        sender: "user",
        text: payload.message,
      });
    },
    addBotMessage: (state, { payload }) => {
      state.messages.push({
        id: Date.now(),
        sender: "bot",
        text: payload.answer,
      });
    },
    setIsLoading: (state) => {
      state.isLoading = true;
    },
    setSuccessMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "success",
        text: payload,
      };
    },
    setErrorMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "error",
        text: payload,
      };
    },
    setIsOpen: (state, { payload }) => {
      state.isOpen = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  addUserMessage,
  addBotMessage,
  setIsLoading,
  setSuccessMessage,
  setErrorMessage,
  setIsOpen,
} = chatBotSlice.actions;
